import { Anchor, Paragraph } from '@zillow/constellation-10';
import { type ComponentProps, useContext } from 'react';
import { AppContext } from '../../contexts/AppContextProvider';

type Props = {
  actionText: string;
  isInLeadManagement?: boolean;
  textStyle?: ComponentProps<typeof Paragraph>['textStyle'];
};

const TermsOfUse = ({ actionText, isInLeadManagement = false, textStyle }: Props) => {
  const { paths } = useContext(AppContext);
  const { corpTermsURL, rentalTermsURL } = paths;

  return (
    <Paragraph
      textStyle={textStyle ?? (isInLeadManagement ? 'body-sm' : 'fineprint')}
      css={{ marginTop: isInLeadManagement ? 0 : 'tight' }}
    >
      {`By clicking ${actionText}, you agree to comply with the `}
      <Anchor href={corpTermsURL} target="_blank">
        Terms of Use
      </Anchor>
      {' and the '}
      <Anchor href={rentalTermsURL} target="_blank">
        Rental User Terms
      </Anchor>
      .
    </Paragraph>
  );
};

export default TermsOfUse;
